"use client";

/**
 * SectionCard — bordered card container for a group of related controls.
 *
 * Variants:
 *  - "default": standard card with full background
 *  - "subtle": dimmer background — use for collapsible/secondary sections
 */
export interface SectionCardProps {
  variant?: "default" | "subtle";
  className?: string;
  children: React.ReactNode;
}

export function SectionCard({
  variant = "default",
  className = "",
  children,
}: SectionCardProps) {
  const bg = variant === "subtle" ? "bg-slate-800/20" : "bg-slate-800/30";
  // GAM Brand v2: section card radius from active skin.
  return (
    <section
      style={{
        borderRadius: "var(--gam-radius-card, 0.75rem)",
        boxShadow: "var(--gam-shadow-card, none)",
      }}
      className={`border border-slate-700/40 ${bg} ${className}`}
    >
      {children}
    </section>
  );
}

/**
 * Visual divider between sub-sections inside a SectionCard.
 */
export function SectionDivider({ className = "" }: { className?: string }) {
  return <div className={`border-t border-slate-700/30 ${className}`} />;
}
